import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

interface ComparisonFeature {
    name: string;
    value?: string;
}

interface ProductSlide {
    title: string;
    subtitle?: string;
    features: ComparisonFeature[];
    icon?: string;
}

@Component({
    selector: 'app-product-comparison',
    templateUrl: './product-comparison.component.html',
    styleUrls: ['./product-comparison.component.scss']
})
export class ProductComparisonComponent implements OnInit {
    currentSlideIndex = 0;

    slides: ProductSlide[] = [
        {
            title: 'IFP Series',
            subtitle: '65" / 75" / 86" / 98"',
            icon: 'devices',
            features: [
                { name: 'Brightness', value: 'Up to 400 nits' },
                { name: 'Touch accuracy', value: '±1mm precision' },
                { name: 'Android version', value: 'Android 13' },
                { name: 'Memory', value: '4GB RAM / 32GB Storage' },
                { name: 'Warranty', value: '3 Years comprehensive' }
            ]
        },
        {
            title: 'AIO PCs & Shutter',
            subtitle: 'All-in-One Solutions',
            icon: 'computer',
            features: [
                { name: 'Processor', value: 'Intel Core i5/i7' },
                { name: 'Storage', value: 'Up to 512GB SSD' },
                { name: 'Safety features', value: 'Auto shutter protection' },
                { name: 'Display', value: '21.5" / 23.8" Full HD' },
                { name: 'Warranty', value: '2 Years onsite' }
            ]
        },
        {
            title: 'LMS Modules',
            subtitle: 'Learning Management System',
            icon: 'school',
            features: [
                { name: 'Teacher tools', value: 'Complete lesson planning suite' },
                { name: 'Student app', value: 'Interactive learning portal' },
                { name: 'Admin dashboard', value: 'Real-time analytics' },
                { name: 'Integration', value: 'Seamless third-party apps' },
                { name: 'Support', value: '24/7 technical assistance' }
            ]
        },
        {
            title: 'K-12 Content',
            subtitle: 'Comprehensive Curriculum',
            icon: 'menu_book',
            features: [
                { name: 'Coverage', value: 'Complete K-12 syllabus' },
                { name: 'Language options', value: 'Multi-language support' },
                { name: 'Video samples', value: '10,000+ educational videos' },
                { name: 'Assessments', value: 'Auto-graded quizzes' },
                { name: 'Updates', value: 'Regular content refresh' }
            ]
        }
    ];

    @ViewChild('cardsContainer') cardsContainer!: ElementRef;

    ngOnInit(): void { }

    scrollLeft(): void {
        this.cardsContainer.nativeElement.scrollBy({ left: -320, behavior: 'smooth' });
    }

    scrollRight(): void {
        this.cardsContainer.nativeElement.scrollBy({ left: 320, behavior: 'smooth' });
    }

    goToSlide(index: number): void {
        const cardWidth = 320; // Approximate width + gap
        this.cardsContainer.nativeElement.scrollTo({ left: index * cardWidth, behavior: 'smooth' });
        this.currentSlideIndex = index;
    }
}
